<template>
  <div>
    <HeaderComponent :pageContent="pageHeader" @change_language="handleHeaderClick"></HeaderComponent>
    <div class="dz-bnr-inr dz-bnr-inr-sm" style="background-image: url(/assets/images/housing/Header.png)">
      <div class="container">
        <div class="dz-bnr-inr-entry">
          <h1 style="color: #0c27bd">{{ pageContent.h1_header }}</h1>
          <!-- <nav aria-label="breadcrumb" class="breadcrumb-row m-t15">
             <ul class="breadcrumb">
               <li class="breadcrumb-item"><a href="index.html">Home</a></li>
               <li class="breadcrumb-item active" aria-current="page">
                 About Us
               </li>
             </ul>
           </nav> -->
        </div>
      </div>
    </div>
    <div class="dz-bnr-inr dz-bnr-inr-sm text-center" style="
        background-image: url(/assets/images/housing/Body1.png);
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      ">
      <div class="container-fluid">
        <h2 class="text-center text-white" style="font-weight: 400">
          {{ pageContent.title }}
        </h2>
        <p class="text-center text-black" style="font-size: 16px; font-weight: 500">
          {{ pageContent.description }}<br />{{ pageContent.description_br1
          }}<br />{{ pageContent.description_br2 }}
        </p>
        <br />
        <div class="row d-flex align-items-stretch">
          <div class="col-md-6 offset-md-3 d-flex">
            <div class="dz-bnr-inr-entry overlay-white h-100" style="text-align: left">
              <h4 class="text-left text-black" style="text-align: center">
                {{ pageContent.housing_support_title }}
              </h4>
              <p class="text-left mb-2 text-black" style="font-size: 16px; text-align: center">
                {{ pageContent.housing_support_text }}
              </p>
              <br />
              <a href="javascript:void(0);" @click="scrollToSection('mapContainer')">
                <button class="btn btn-primary d-block mx-auto">
                  {{ pageContent.find_school_button }}
                </button>
              </a>
            </div>
          </div>
        </div>
        <br /><br />
        <router-link :to="'/contact-us'">
          <button class="bg-white btn d-block mx-auto text-primary" style="padding: 15px 60px; border-radius: 25px">
            {{ pageContent.get_in_touch_button }}
          </button>
        </router-link>
      </div>
    </div>
    <div class="dz-bnr-inr dz-bnr-inr-sm text-center" style="
        background: #f0f1f5;
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px 0px;
        min-height: 200px;
        height: auto;
      ">
      <div class="container">
        <div class="row bg-white" style="padding: 50px 0px">
          <div class="col-md-3">
            <a href="https://rentinstpete.com/">
              <img src="/assets/images/housing/1.jpeg" class="img-fluid d-block mx-auto" alt="" />
            </a>
          </div>
          <div class="col-md-3" style="text-align: left">
            <p class="text-left text-black">
              Dean & Dewitt Property Management Address: St. Petersburg,
              Florida<br /><br />

              Offers professional property management services to make investing
              in real estate effortless
            </p>
          </div>
          <div class="col-md-3">
            <a href="https://impactrealtytampa.com/" target="_blank">
              <img src="/assets/images/housing/2.png" class="img-fluid d-block mx-auto" alt="" /></a>
          </div>
          <div class="col-md-3" style="text-align: left">
            <p class="text-left text-black">
              Impact Realty Address: Tampa Bay, Florida<br /><br />

              Impact Realty Tampa Bay is a client-focused brokerage specializing
              in buying, selling, and investing in Tampa Bay real estate.
            </p>
          </div>
        </div>
      </div>
      <br /><br />
      <!-- <div class="row" id="map">
        <div class="col-md-7">
          <iframe
            src="https://www.google.com/maps/d/embed?mid=1eqRuqdMuJ5iaYahc5vFwm-xNl5XrnCw&ehbc=2E312F"
            width="100%"
            height="500"
          ></iframe>
        </div>
        <div class="col-md-5">
          <div class="card">
            <div class="card-body" style="text-align: left">
              <h4 class="text-primary">Dean & DeWitt Property Management</h4>
              <p>
                Specializes in managing historic homes, apartment buildings,
                condominiums, and investment properties. Offers professional
                property management services to make investing in real estate
                effortless.
              </p>
              <br />
              <p class="text-primary">Nearby Schools</p>
              <p>
                North Shore Elementary, John Hopkins Middle, St. Petersburg High
              </p>
              <br /><br />
              <h4 class="text-primary">Atrium Property Management</h4>
              <p>
                Provides full, professional leasing and management services,
                handling all aspects of managing rental properties. Offers a
                free rental analysis to optimize rental value.
              </p>
              <br />
              <p class="text-primary">Nearby Schools</p>
              <p>Lakewood Elementary, Bay Point Middle, Lakewood High</p>
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <div class="container-fluid" id="mapContainer">
      <br />
      <div class="row">
        <div class="col-md-12" v-if="isAllLoaded">
          <v-select
            v-model="selectedSchool"
            :options="schools"
            label="schoolName"
            :filter="filterSchoolOptions"
            :get-option-key="getSchoolOptionKey"
            placeholder="Filter by School"
            @update:modelValue="filterBySchool"
          />
          <button
            class="btn btn-primary mt-2 w-100"
            @click="resetFilter"
            v-if="selectedSchool"
          >
            {{ pageContent.reset_button }}
          </button>
        </div>
      </div>
      <br />
    </div>
    <div class="schools-explorer">
      <!-- LEFT SIDEBAR -->
      <aside class="explorer-sidebar" :class="{ collapsed: sidebarCollapsed }">
        <div class="sidebar-inner">
          <!-- Content: details or list -->
          <div class="sidebar-content">
            <!-- DETAILS PANEL -->
            <div v-if="selectedSchool" class="details-panel">
              <button class="back-btn" @click="clearSelection">
                <i class="fa fa-arrow-left"></i> Back to list
              </button>

              <div class="details-header">
                <h3 class="details-title">{{ selectedSchool.schoolName }}</h3>
              </div>

              <div class="details-actions">
                <a
                  class="action-btn"
                  :href="selectedSchoolDirectionsLink"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="fa fa-diamond-turn-right"></i><span>Directions</span>
                </a>
                <a
                  v-if="selectedSchool.website || selectedSchool.schoolWebsite"
                  class="action-btn"
                  :href="ensureHttp(selectedSchool.website || selectedSchool.schoolWebsite)"
                  target="_blank"
                  rel="noopener"
                >
                  <i class="fa fa-globe"></i><span>Website</span>
                </a>
                <button class="action-btn" @click="copyShareLink(selectedSchool)">
                  <i class="fa fa-share-nodes"></i><span>Share</span>
                </button>
              </div>

              <!-- School info -->
              <div class="info-section">
                <h5 class="section-heading">School Information</h5>
                <ul class="info-list">
                  <li v-if="selectedSchoolFullAddress">
                    <i class="fa fa-location-dot"></i>
                    <span>{{ selectedSchoolFullAddress }}</span>
                  </li>
                  <li v-if="selectedSchool.county">
                    <i class="fa fa-map"></i>
                    <span>{{ selectedSchool.county }} County</span>
                  </li>
                  <li v-if="selectedSchool.phone">
                    <i class="fa fa-phone"></i>
                    <a :href="'tel:' + selectedSchool.phone">{{ selectedSchool.phone }}</a>
                  </li>
                  <li v-if="selectedSchool.schoolEmail">
                    <i class="fa fa-envelope"></i>
                    <a :href="'mailto:' + selectedSchool.schoolEmail">{{ selectedSchool.schoolEmail }}</a>
                  </li>
                </ul>
              </div>

              <!-- Nearby amenities -->
              <div class="info-section">
                <div class="section-heading-row">
                  <h5 class="section-heading">Nearby Amenities</h5>
                  <select v-model.number="nearbyRadiusMiles" @change="reloadNearby" class="form-control form-control-sm radius-select">
                    <option :value="1">1 mile</option>
                    <option :value="3">3 miles</option>
                    <option :value="5">5 miles</option>
                    <option :value="10">10 miles</option>
                  </select>
                </div>

                <div v-if="nearbyLoading" class="nearby-loading">
                  <div class="spinner"></div>
                  <span>Searching nearby places...</span>
                </div>

                <div v-else class="nearby-categories">
                  <div
                    v-for="cat in amenityCategories"
                    :key="cat.key"
                    class="nearby-category"
                  >
                    <button
                      class="cat-header"
                      @click="toggleCategory(cat.key)"
                      :disabled="!(nearbyPlaces[cat.key] && nearbyPlaces[cat.key].length)"
                    >
                      <span class="cat-icon" :style="{ background: cat.color }">
                        <i :class="cat.icon"></i>
                      </span>
                      <span class="cat-label">{{ cat.label }}</span>
                      <span class="cat-count">
                        {{ (nearbyPlaces[cat.key] && nearbyPlaces[cat.key].length) || 0 }}
                      </span>
                      <i
                        class="fa cat-chevron"
                        :class="expandedCategories[cat.key] ? 'fa-chevron-up' : 'fa-chevron-down'"
                      ></i>
                    </button>
                    <ul
                      v-if="expandedCategories[cat.key] && nearbyPlaces[cat.key] && nearbyPlaces[cat.key].length"
                      class="cat-places"
                    >
                      <li
                        v-for="place in nearbyPlaces[cat.key]"
                        :key="place.id"
                        @mouseenter="highlightPlaceMarker(place.id)"
                        @mouseleave="unhighlightPlaceMarker(place.id)"
                        @click="focusPlace(place)"
                      >
                        <div class="place-name">{{ place.name }}</div>
                        <div class="place-meta">
                          <span :title="'Straight-line distance from school'"><i class="fa fa-ruler"></i> ~{{ formatDistance(place.distanceMiles) }}</span>
                          <span :title="'Estimated driving time (rough)'"><i class="fa fa-car"></i> ~{{ formatMinutes(place.drivingMinutes) }}</span>
                          <span :title="'Estimated walking time (rough)'"><i class="fa fa-person-walking"></i> ~{{ formatMinutes(place.walkingMinutes) }}</span>
                        </div>
                        <a
                          class="place-directions"
                          :href="googleMapsDirectionsLink(selectedSchool, place)"
                          target="_blank"
                          rel="noopener"
                          @click.stop
                        >
                          <i class="fa fa-diamond-turn-right"></i> Get directions
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <!-- EMPTY STATE -->
            <div v-else class="empty-panel">
              <i class="fa fa-school empty-icon"></i>
              <div class="empty-title">No school selected</div>
              <div class="empty-sub">
                Use the “Filter by School” dropdown above the map, or click a marker, to see details and nearby amenities.
              </div>
            </div>
          </div>
        </div>

        <button
          class="sidebar-toggle"
          :class="{ collapsed: sidebarCollapsed }"
          @click="toggleSidebar"
          :title="sidebarCollapsed ? 'Show sidebar' : 'Hide sidebar'"
        >
          <i class="fa" :class="sidebarCollapsed ? 'fa-chevron-right' : 'fa-chevron-left'"></i>
        </button>
      </aside>

      <!-- RIGHT MAP PANEL -->
      <section class="explorer-map-wrapper">
        <div class="map-toolbar">
          <button class="tool-btn" @click="fitAllSchools" title="Fit all schools">
            <i class="fa fa-expand"></i>
          </button>
          <button class="tool-btn" @click="resetMap" title="Reset map">
            <i class="fa fa-rotate-left"></i>
          </button>
          <button class="tool-btn" @click="centerOnUser" title="My location">
            <i class="fa fa-location-crosshairs"></i>
          </button>
          <button class="tool-btn" @click="toggleMapType" :title="currentMapType === 'roadmap' ? 'Satellite view' : 'Map view'">
            <i class="fa" :class="currentMapType === 'roadmap' ? 'fa-satellite' : 'fa-map'"></i>
          </button>
          <button class="tool-btn" @click="toggleMeasureMode" :class="{ active: measureMode }" title="Measure distance">
            <i class="fa fa-ruler"></i>
          </button>
        </div>

        <div id="googleMap"></div>

        <div v-if="measureMode && measurePoints.length" class="measure-readout">
          <span>Distance: <strong>{{ formatDistance(measureDistanceMiles) }}</strong></span>
          <button class="btn btn-sm btn-link" @click="clearMeasure">Clear</button>
        </div>

        <div v-if="!isAllLoaded" class="map-loading-overlay">
          <div class="spinner spinner-lg"></div>
          <span>Loading schools...</span>
        </div>
      </section>
    </div>

    <div class="dz-bnr-inr dz-bnr-inr-sm text-center" style="
        background-image: url(/assets/images/housing/Body2.png);
        background-size: cover;
        background-position: bottom;
        padding: 50px 0px;
        min-height: 300px;
        height: auto;
      ">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="dz-bnr-inr-entry" style="
                background-color: rgba(
                  255,
                  255,
                  255,
                  0.9
                ); /* White with 80% opacity */
                padding: 50px;
                border-radius: 10px;
                color: black;
              ">
              <h1 class="text-left text-primary" style="font-weight: 400">
                {{ pageContent.strong_start_title }}
              </h1>
            </div>
          </div>
        </div>
        <br /><br />
        <router-link :to="'/contact-us'">
          <button class="btn btn-primary d-block mx-auto text-white" style="padding: 15px 60px; border-radius: 25px">
            {{ pageContent.contact_us_button }}
          </button>
        </router-link>
      </div>
    </div>

    <FooterComponent :pageContent="pageFooter"></FooterComponent>
  </div>
</template>
<script>
// @ is an alias to /src
import { markRaw } from "vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import FooterComponent from "@/components/FooterComponent.vue";
import { Loader } from "@googlemaps/js-api-loader";
import { collection, getDocs, orderBy, query } from "firebase/firestore";
import { firestore } from "@/firebase";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import globalMixins from "@/plugins/globalMixins";

const GOOGLE_MAPS_API_KEY = "AIzaSyBi70_IN0DPJiGTL_vbioxhE6iOzXQoXNU";

// Configurable amenity categories. Each maps to one or more Google Places
// "primary types" (Places API New). Some entries use textQuery for branded
// chains where there isn't a dedicated type.
const AMENITY_CATEGORIES = [
  { key: "hospitals",    label: "Hospitals",        icon: "fa fa-hospital",          color: "#e53935", types: ["hospital"] },
  { key: "urgent_care",  label: "Urgent Care",      icon: "fa fa-briefcase-medical", color: "#ef5350", textQuery: "urgent care" },
  { key: "pharmacies",   label: "Pharmacies",       icon: "fa fa-prescription-bottle-medical", color: "#8e24aa", types: ["pharmacy", "drugstore"] },
  { key: "cvs",          label: "CVS",              icon: "fa fa-store",             color: "#c62828", textQuery: "CVS" },
  { key: "walgreens",    label: "Walgreens",        icon: "fa fa-store",             color: "#d32f2f", textQuery: "Walgreens" },
  { key: "publix",       label: "Publix",           icon: "fa fa-cart-shopping",     color: "#2e7d32", textQuery: "Publix" },
  { key: "walmart",      label: "Walmart",          icon: "fa fa-cart-shopping",     color: "#1565c0", textQuery: "Walmart" },
  { key: "target",       label: "Target",           icon: "fa fa-cart-shopping",     color: "#cc0000", textQuery: "Target store" },
  { key: "costco",       label: "Costco",           icon: "fa fa-cart-shopping",     color: "#005daa", textQuery: "Costco" },
  { key: "grocery",      label: "Grocery Stores",   icon: "fa fa-basket-shopping",   color: "#43a047", types: ["supermarket", "convenience_store"] },
  { key: "restaurants",  label: "Restaurants",      icon: "fa fa-utensils",          color: "#fb8c00", types: ["restaurant"] },
  { key: "coffee",       label: "Coffee Shops",     icon: "fa fa-mug-hot",           color: "#6d4c41", types: ["cafe"] },
  { key: "gas",          label: "Gas Stations",     icon: "fa fa-gas-pump",          color: "#fdd835", types: ["gas_station"] },
  { key: "parks",        label: "Parks",            icon: "fa fa-tree",              color: "#2e7d32", types: ["park"] },
  { key: "libraries",    label: "Libraries",        icon: "fa fa-book",              color: "#5e35b1", types: ["library"] },
  { key: "police",       label: "Police Stations",  icon: "fa fa-shield-halved",     color: "#1565c0", types: ["police"] },
  { key: "fire",         label: "Fire Stations",    icon: "fa fa-fire-extinguisher", color: "#d84315", types: ["fire_station"] },
  { key: "transit",      label: "Public Transit",   icon: "fa fa-bus",               color: "#00838f", types: ["bus_station", "transit_station", "subway_station", "train_station"] },
];

// Selected-school pin color.
const SELECTED_SCHOOL_PIN_COLOR = "#d50000";

const DEFAULT_CENTER = { lat: 27.9944024, lng: -81.7602544 }; // Florida center
const DEFAULT_ZOOM = 7;
const SELECTED_SCHOOL_ZOOM = 16;

export default {
  name: "HousingAssistance",
  components: {
    HeaderComponent,
    FooterComponent,
    vSelect,
  },
  data() {
    return {
      // Google Maps state
      map: null,
      google: null,
      loader: null,
      AdvancedMarkerElement: null,
      PinElement: null,
      sharedInfoWindow: null,
      currentMapType: "roadmap",

      // School data
      schools: [],
      isAllLoaded: false,

      // Selection state
      selectedSchool: null,
      selectedSchoolOverlayMarker: null,

      // Sidebar
      sidebarCollapsed: false,

      // Nearby amenities. The category list is static config, so keep it out
      // of the reactivity system.
      amenityCategories: markRaw(AMENITY_CATEGORIES),
      nearbyRadiusMiles: 5,
      nearbyPlaces: {}, // key -> [{ id, name, lat, lng, distanceMiles, ... }]
      placeMarkers: {}, // key -> [marker, marker, ...]
      placeMarkerById: {}, // placeId -> marker (for hover highlight)
      nearbyLoading: false,
      expandedCategories: {},
      nearbyRequestToken: 0,

      // Measure tool
      measureMode: false,
      measurePoints: [], // [{lat,lng}, {lat,lng}]
      measureMarkers: [],
      measurePolyline: null,
      measureDistanceMiles: 0,

      // i18n
      pageContent: [],
      pageHeader: [],
      pageFooter: [],
      language: "en",
    };
  },
  computed: {
    selectedSchoolFullAddress() {
      return this.selectedSchool ? this.formatFullAddress(this.selectedSchool) : "";
    },
    selectedSchoolDirectionsLink() {
      return this.selectedSchool
        ? this.googleMapsDirectionsLinkForSchool(this.selectedSchool)
        : "https://www.google.com/maps";
    },
  },
  async mounted() {
    const storedLanguage = localStorage.getItem("language");
    if (storedLanguage) this.language = storedLanguage;
    this.convertLanguage();
    await this.loadMap();
    await this.fetchSchools();
  },
  beforeUnmount() {
    // Tear down in an order that lets Google Maps' WebGL renderer finish
    // any in-flight frames cleanly. This reduces noisy
    // "CONTEXT_LOST_WEBGL" / "delete: object does not belong to this
    // context" messages logged by webgl.js during navigation.
    try {
      this.clearPlaceMarkers();
      this.clearMeasure();
      this._clearSelectedSchoolOverlay();
      if (this.sharedInfoWindow) {
        this.sharedInfoWindow.close();
        this.sharedInfoWindow = null;
      }
      if (this.google && this.map) {
        this.google.maps.event.clearInstanceListeners(this.map);
      }
      this.map = null;
    } catch (e) {
      // Swallow teardown errors — they only matter at unmount.
      // eslint-disable-next-line no-console
      console.debug("Map teardown:", e);
    }
  },
  methods: {
    // ---------- Map bootstrap ----------
    async loadMap() {
      // Google Maps objects (Map, markers, loader, etc.) contain deeply nested
      // circular references. Vue 3 would try to make them deeply reactive,
      // which recurses infinitely and throws "Maximum call stack size
      // exceeded". markRaw() keeps them out of the reactivity system.
      this.loader = markRaw(new Loader({
        apiKey: GOOGLE_MAPS_API_KEY,
        version: "quarterly",
        libraries: ["places", "marker"],
      }));
      const googleMaps = await this.loader.importLibrary("maps");
      await this.loader.importLibrary("places");
      const markerLib = await this.loader.importLibrary("marker");
      this.AdvancedMarkerElement = markRaw(markerLib.AdvancedMarkerElement);
      this.PinElement = markRaw(markerLib.PinElement);
      this.google = markRaw(window.google);

      this.map = markRaw(new googleMaps.Map(document.getElementById("googleMap"), {
        center: DEFAULT_CENTER,
        zoom: DEFAULT_ZOOM,
        mapId: "215ceae1543f2b22",
        mapTypeId: this.currentMapType,
        mapTypeControl: false,
        streetViewControl: true,
        fullscreenControl: true,
        zoomControl: true,
      }));

      this.sharedInfoWindow = markRaw(new this.google.maps.InfoWindow());
      this.map.addListener("click", (e) => {
        if (this.measureMode && e && e.latLng) {
          this._handleMeasureClick(e.latLng);
          return;
        }
        if (this.sharedInfoWindow) this.sharedInfoWindow.close();
      });
    },

    // ---------- School data load ----------
    async fetchSchools() {
      const schoolsRef = collection(firestore, "schools");
      const q = query(schoolsRef, orderBy("schoolName", "asc"));
      const querySnapshot = await getDocs(q);
      // Schools are read-only display data. markRaw keeps Vue from deeply
      // proxying every school object (significant overhead for large lists);
      // selection swaps the `selectedSchool` reference, which stays reactive.
      const schools = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      this.schools = markRaw(schools);
      this._buildSchoolSearchIndex(schools);
      this.isAllLoaded = true;
    },

    // Precompute a normalized search haystack per school so the v-select
    // filter does not re-normalize every option on each keystroke.
    _buildSchoolSearchIndex(schools) {
      const index = new Map();
      schools.forEach((school) => {
        const haystack = `${this._normalizeText(school.schoolName)} ${this._normalizeText(school.state)}`;
        index.set(school, haystack);
      });
      this._schoolSearchIndex = index;
    },

    // ---------- Selection ----------
    _clearSelectedSchoolOverlay() {
      if (this.selectedSchoolOverlayMarker) {
        if (typeof this.selectedSchoolOverlayMarker.setMap === "function") {
          this.selectedSchoolOverlayMarker.setMap(null);
        } else {
          this.selectedSchoolOverlayMarker.map = null;
        }
        this.selectedSchoolOverlayMarker = null;
      }
    },

    _buildSelectedSchoolMarkerContent() {
      // White school glyph (Material "school" icon) supplied as an image. The
      // `glyph`/`element` PinElement APIs are deprecated in favor of
      // `glyphSrc` and using the PinElement instance directly as content.
      const schoolSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#ffffff"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3 1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>`;
      const glyphSrc = `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(schoolSvg)}`;

      const pin = new this.PinElement({
        background: SELECTED_SCHOOL_PIN_COLOR,
        borderColor: "#ffffff",
        scale: 1.6,
      });
      pin.glyphSrc = glyphSrc;

      // Mimic the classic Marker DROP animation via CSS.
      pin.classList.add("selected-school-drop");
      return pin;
    },

    _showSelectedSchoolOverlay(school, lat, lng) {
      if (!this.map || !this.AdvancedMarkerElement) return;
      this._clearSelectedSchoolOverlay();

      this.selectedSchoolOverlayMarker = markRaw(
        new this.AdvancedMarkerElement({
          position: { lat, lng },
          map: this.map,
          title: school.schoolName || "",
          content: this._buildSelectedSchoolMarkerContent(),
          zIndex: 999999,
          gmpClickable: true,
        })
      );

      this.selectedSchoolOverlayMarker.addListener("gmp-click", () => {
        this.selectSchool(school);
      });
    },

    _focusMapOnSchool(lat, lng) {
      if (!this.map) return;
      this.map.setCenter({ lat, lng });
      this.map.setZoom(SELECTED_SCHOOL_ZOOM);
    },

    _resolveSchool(school) {
      if (!school) return null;
      if (school.id) {
        const byId = this.schools.find((s) => s.id === school.id);
        if (byId) return byId;
      }
      if (school.schoolName) {
        const byName = this.schools.find((s) => s.schoolName === school.schoolName);
        if (byName) return byName;
      }
      return school;
    },

    async _resolveSchoolCoords(school) {
      const resolved = this._resolveSchool(school);
      let { lat, lng } = this.normalizeSchoolCoords(resolved);
      if (!isNaN(lat) && !isNaN(lng)) {
        return { school: resolved, lat, lng };
      }

      const address = this.formatFullAddress(resolved);
      if (!address || !this.google) {
        return { school: resolved, lat: NaN, lng: NaN };
      }

      try {
        const geocoder = new this.google.maps.Geocoder();
        const { results } = await geocoder.geocode({ address });
        if (results && results[0]) {
          const loc = results[0].geometry.location;
          lat = loc.lat();
          lng = loc.lng();
          return { school: resolved, lat, lng };
        }
      } catch (err) {
        console.warn("School geocode failed:", err && err.message);
      }
      return { school: resolved, lat: NaN, lng: NaN };
    },

    async selectSchool(school) {
      if (!school) return;

      const { school: resolvedSchool, lat, lng } = await this._resolveSchoolCoords(school);
      if (isNaN(lat) || isNaN(lng)) return;

      this._clearSelectedSchoolOverlay();
      this.selectedSchool = resolvedSchool;
      this._showSelectedSchoolOverlay(resolvedSchool, lat, lng);
      this._focusMapOnSchool(lat, lng);

      await this.reloadNearby();
    },

    clearSelection() {
      this._clearSelectedSchoolOverlay();
      this.selectedSchool = null;
      this.nearbyPlaces = {};
      this.expandedCategories = {};
      this.clearPlaceMarkers();
      if (this.sharedInfoWindow) this.sharedInfoWindow.close();
    },

    // ---------- Nearby amenities ----------
    async reloadNearby() {
      if (!this.selectedSchool || !this.google) return;
      this.clearPlaceMarkers();
      this.nearbyPlaces = {};
      this.expandedCategories = {};
      this.nearbyLoading = true;

      const token = ++this.nearbyRequestToken;
      const { lat, lng } = this.normalizeSchoolCoords(this.selectedSchool);
      const center = { lat: parseFloat(lat), lng: parseFloat(lng) };
      const radiusMeters = Math.max(500, Math.round(this.nearbyRadiusMiles * 1609.34));

      try {
        const { Place } = await this.google.maps.importLibrary("places");

        // Fire all category searches in parallel
        const promises = this.amenityCategories.map((cat) =>
          this._fetchCategory(Place, cat, center, radiusMeters).then((res) => ({ cat, res }))
        );
        const results = await Promise.all(promises);
        if (token !== this.nearbyRequestToken) return; // stale

        const next = {};
        const nextMarkers = {};
        const seenIds = new Set();
        results.forEach(({ cat, res }) => {
          let places = (res || []).map((p) => this._normalizePlace(p, center));
          // Brand text searches use locationBias (a soft preference), so the
          // API can return places far outside the selected radius. Enforce
          // the radius here for those categories.
          if (cat.textQuery) {
            places = places.filter(
              (p) => isFinite(p.distanceMiles) && p.distanceMiles <= this.nearbyRadiusMiles
            );
          }
          // Dedupe across categories by place id (e.g. a CVS that also
          // matches Pharmacies should not render twice on the map).
          places = places.filter((p) => {
            if (!p.id || seenIds.has(p.id)) return false;
            seenIds.add(p.id);
            return true;
          });
          places.sort((a, b) => a.distanceMiles - b.distanceMiles);
          // Trim to top N per category to keep the UI manageable
          next[cat.key] = places.slice(0, 8);
          nextMarkers[cat.key] = next[cat.key].map((p) => this._addPlaceMarker(p, cat));
        });
        this.nearbyPlaces = next;
        this.placeMarkers = nextMarkers;
        // Auto-expand the most relevant categories
        ["hospitals", "publix", "pharmacies", "parks"].forEach((k) => {
          if (next[k] && next[k].length) this.expandedCategories[k] = true;
        });
      } catch (err) {
        console.error("Nearby amenities search failed:", err);
      } finally {
        if (token === this.nearbyRequestToken) {
          this.nearbyLoading = false;
        }
      }
    },

    async _fetchCategory(Place, cat, center, radiusMeters) {
      // NOTE: Field names here are the Place class property names exposed by
      // the Maps JS API (camelCase). "websiteURI" is intentionally omitted
      // because it is unsupported in searchNearby / searchByText field masks
      // and rejects the entire request when included.
      const PLACE_FIELDS = [
        "id",
        "displayName",
        "location",
        "formattedAddress",
        "rating",
      ];
      try {
        if (cat.textQuery) {
          const req = {
            textQuery: cat.textQuery,
            fields: PLACE_FIELDS,
            locationBias: { center, radius: radiusMeters },
            maxResultCount: 10,
            language: "en-US",
            region: "us",
          };
          const { places } = await Place.searchByText(req);
          return places || [];
        } else {
          const req = {
            fields: PLACE_FIELDS,
            locationRestriction: { center, radius: radiusMeters },
            // includedTypes (vs includedPrimaryTypes) returns places that
            // have any of the listed types, not just those whose *primary*
            // type matches. This catches hospitals tagged primarily as
            // "health", Walmarts tagged as "department_store", etc.
            includedTypes: cat.types,
            maxResultCount: 20,
            language: "en-US",
            region: "us",
          };
          const { places } = await Place.searchNearby(req);
          return places || [];
        }
      } catch (err) {
        // One bad category should not break the others
        console.warn("Category search failed:", cat.key, err && err.message);
        return [];
      }
    },

    _normalizePlace(place, center) {
      const loc = place.location;
      let pLat = null, pLng = null;
      if (loc) {
        pLat = typeof loc.lat === "function" ? loc.lat() : loc.latitude;
        pLng = typeof loc.lng === "function" ? loc.lng() : loc.longitude;
      }
      const name =
        (place.displayName && (place.displayName.text || place.displayName)) ||
        "Unknown";
      const distanceMiles = this._haversineMiles(center.lat, center.lng, pLat, pLng);
      return {
        id: place.id,
        name,
        lat: pLat,
        lng: pLng,
        address: place.formattedAddress || "",
        rating: place.rating || null,
        distanceMiles,
        drivingMinutes: (distanceMiles / 30) * 60, // ~30 mph
        walkingMinutes: (distanceMiles / 3) * 60,  // ~3 mph
      };
    },

    _addPlaceMarker(place, cat) {
      if (!this.map || !this.AdvancedMarkerElement || place.lat == null || place.lng == null) {
        return null;
      }
      const content = document.createElement("div");
      content.className = "place-marker";
      content.innerHTML = `
        <div class="place-pin" style="background:${cat.color};" title="${this.escapeHtml(place.name)}">
          <i class="${cat.icon}"></i>
        </div>
      `;
      const marker = markRaw(
        new this.AdvancedMarkerElement({
          position: { lat: place.lat, lng: place.lng },
          map: this.map,
          content,
          title: place.name,
          gmpClickable: true,
        })
      );
      marker.addListener("gmp-click", () => {
        this._showPlaceInfo(marker, place, cat);
      });
      this.placeMarkerById[place.id] = marker;
      return marker;
    },

    _showPlaceInfo(marker, place, cat) {
      if (!this.sharedInfoWindow) return;
      const directionsUrl = this.googleMapsDirectionsLink(this.selectedSchool, place);
      const html = `
        <div style="max-width:280px;font-family:inherit;">
          <div style="display:flex;align-items:center;gap:8px;margin-bottom:6px;">
            <span style="display:inline-flex;width:24px;height:24px;border-radius:50%;background:${cat.color};color:#fff;align-items:center;justify-content:center;font-size:11px;">
              <i class="${cat.icon}"></i>
            </span>
            <strong style="font-size:14px;">${this.escapeHtml(place.name)}</strong>
          </div>
          <div style="font-size:12px;color:#555;margin-bottom:4px;">${this.escapeHtml(place.address || "")}</div>
          <div style="font-size:12px;margin-bottom:4px;">
            ${place.rating ? "★ " + place.rating + " &middot; " : ""}
            ~${this.formatDistance(place.distanceMiles)} away
          </div>
          <div style="font-size:11px;color:#777;margin-bottom:8px;">
            🚗 ~${this.formatMinutes(place.drivingMinutes)}
            &nbsp;|&nbsp;
            🚶 ~${this.formatMinutes(place.walkingMinutes)}
            <div style="font-size:10px;color:#999;margin-top:2px;">(rough estimates — straight-line)</div>
          </div>
          <a href="${directionsUrl}" target="_blank" rel="noopener"
             style="display:inline-block;background:#1a73e8;color:#fff;padding:6px 12px;border-radius:4px;text-decoration:none;font-size:12px;">
            Directions
          </a>
        </div>
      `;
      this.sharedInfoWindow.setContent(html);
      this.sharedInfoWindow.open({ map: this.map, anchor: marker });
    },

    clearPlaceMarkers() {
      Object.values(this.placeMarkers).forEach((markers) => {
        (markers || []).forEach((m) => {
          if (!m) return;
          if ("map" in m) m.map = null;
          else if (typeof m.setMap === "function") m.setMap(null);
        });
      });
      this.placeMarkers = {};
      this.placeMarkerById = {};
    },

    focusPlace(place) {
      if (!this.map || place.lat == null || place.lng == null) return;
      this.map.panTo({ lat: place.lat, lng: place.lng });
      const marker = this.placeMarkerById[place.id];
      if (marker) {
        const cat = this.amenityCategories.find((c) =>
          (this.nearbyPlaces[c.key] || []).some((p) => p.id === place.id)
        );
        if (cat) this._showPlaceInfo(marker, place, cat);
      }
    },

    highlightPlaceMarker(id) {
      const m = this.placeMarkerById[id];
      if (m && m.content) {
        const pin = m.content.querySelector(".place-pin");
        if (pin) pin.classList.add("hover");
      }
    },
    unhighlightPlaceMarker(id) {
      const m = this.placeMarkerById[id];
      if (m && m.content) {
        const pin = m.content.querySelector(".place-pin");
        if (pin) pin.classList.remove("hover");
      }
    },

    // ---------- Search / sidebar ----------
    toggleSidebar() {
      this.sidebarCollapsed = !this.sidebarCollapsed;
      // Trigger a map resize so it fills the new space
      this.$nextTick(() => {
        if (this.google && this.map) {
          this.google.maps.event.trigger(this.map, "resize");
        }
      });
    },
    toggleCategory(key) {
      this.expandedCategories[key] = !this.expandedCategories[key];
    },

    // ---------- Legacy v-select filter handlers (above the map) ----------
    filterSchoolOptions(options, search) {
      const normalizedSearch = this._normalizeText(search);
      if (!normalizedSearch) return options;
      const index = this._schoolSearchIndex;
      return options.filter((school) => {
        const haystack =
          (index && index.get(school)) ||
          `${this._normalizeText(school.schoolName)} ${this._normalizeText(school.state)}`;
        return haystack.includes(normalizedSearch);
      });
    },
    getSchoolOptionKey(school) {
      return school.id || school.schoolName;
    },
    filterBySchool(school) {
      // v-select emits the selected option (or null when cleared)
      if (!school) {
        this.clearSelection();
        return;
      }
      this.selectSchool(school);
    },
    resetFilter() {
      this.selectedSchool = null;
      this.clearSelection();
      this._refreshMapView();
    },

    _refreshMapView() {
      if (!this.map || !this.google) return;
      this.fitAllSchools();
      this.$nextTick(() => {
        this.google.maps.event.trigger(this.map, "resize");
      });
    },

    // ---------- Map controls ----------
    fitAllSchools() {
      if (!this.google || !this.map) return;
      const bounds = new this.google.maps.LatLngBounds();
      let count = 0;
      this.schools.forEach((s) => {
        const { lat, lng } = this.normalizeSchoolCoords(s);
        if (!isNaN(lat) && !isNaN(lng)) {
          bounds.extend({ lat, lng });
          count++;
        }
      });
      if (count > 0) this.map.fitBounds(bounds);
    },
    resetMap() {
      if (!this.map) return;
      this.clearSelection();
      this.map.setCenter(DEFAULT_CENTER);
      this.map.setZoom(DEFAULT_ZOOM);
    },
    centerOnUser() {
      if (!navigator.geolocation || !this.map) return;
      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const center = { lat: pos.coords.latitude, lng: pos.coords.longitude };
          this.map.panTo(center);
          this.map.setZoom(13);
        },
        (err) => console.warn("Geolocation failed:", err && err.message)
      );
    },
    toggleMapType() {
      this.currentMapType = this.currentMapType === "roadmap" ? "hybrid" : "roadmap";
      if (this.map) this.map.setMapTypeId(this.currentMapType);
    },

    // ---------- Measure tool ----------
    toggleMeasureMode() {
      this.measureMode = !this.measureMode;
      if (!this.measureMode) this.clearMeasure();
    },
    _handleMeasureClick(latLng) {
      if (this.measurePoints.length >= 2) this.clearMeasure();
      const point = { lat: latLng.lat(), lng: latLng.lng() };
      this.measurePoints.push(point);

      const dotContent = document.createElement("div");
      dotContent.innerHTML = `<div style="width:12px;height:12px;border-radius:50%;background:#1a73e8;border:2px solid #fff;box-shadow:0 0 0 1px #1a73e8;"></div>`;
      const m = markRaw(
        new this.AdvancedMarkerElement({
          position: point,
          map: this.map,
          content: dotContent,
        })
      );
      this.measureMarkers.push(m);

      if (this.measurePoints.length === 2) {
        this.measurePolyline = markRaw(
          new this.google.maps.Polyline({
            path: this.measurePoints,
            map: this.map,
            strokeColor: "#1a73e8",
            strokeOpacity: 0.9,
            strokeWeight: 3,
          })
        );
        const [a, b] = this.measurePoints;
        this.measureDistanceMiles = this._haversineMiles(a.lat, a.lng, b.lat, b.lng);
      }
    },
    clearMeasure() {
      this.measurePoints = [];
      this.measureDistanceMiles = 0;
      this.measureMarkers.forEach((m) => {
        if (!m) return;
        if ("map" in m) m.map = null;
      });
      this.measureMarkers = [];
      if (this.measurePolyline) {
        this.measurePolyline.setMap(null);
        this.measurePolyline = null;
      }
    },

    // ---------- Helpers ----------
    formatSchoolLocation(s) {
      const parts = [s.city, s.state, s.zipCode].filter(Boolean);
      return parts.join(", ");
    },
    formatFullAddress(s) {
      const line1 = s.address ? s.address : "";
      const line2 = this.formatSchoolLocation(s);
      return [line1, line2].filter(Boolean).join(", ");
    },
    formatDistance(miles) {
      if (miles == null || isNaN(miles)) return "—";
      if (miles < 0.1) return Math.round(miles * 5280) + " ft";
      return miles.toFixed(1) + " mi";
    },
    formatMinutes(mins) {
      if (mins == null || isNaN(mins)) return "—";
      if (mins < 1) return "<1 min";
      if (mins < 60) return Math.round(mins) + " min";
      const h = Math.floor(mins / 60);
      const m = Math.round(mins % 60);
      return `${h}h ${m}m`;
    },
    googleMapsDirectionsLinkForSchool(school) {
      const { lat, lng } = this.normalizeSchoolCoords(school);
      if (isNaN(lat) || isNaN(lng)) return "https://www.google.com/maps";
      const q = encodeURIComponent(
        this.formatFullAddress(school) || `${lat},${lng}`
      );
      return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}&destination_place_id=&query=${q}`;
    },
    googleMapsDirectionsLink(school, place) {
      if (!school || !place) return "https://www.google.com/maps";
      const s = this.normalizeSchoolCoords(school);
      if (isNaN(s.lat) || isNaN(s.lng) || place.lat == null || place.lng == null) {
        return "https://www.google.com/maps";
      }
      return `https://www.google.com/maps/dir/?api=1&origin=${s.lat},${s.lng}&destination=${place.lat},${place.lng}`;
    },
    ensureHttp(url) {
      if (!url) return "#";
      return /^https?:\/\//i.test(url) ? url : `https://${url}`;
    },
    async copyShareLink(school) {
      const url = `${window.location.origin}${window.location.pathname}?school=${encodeURIComponent(school.id)}`;
      try {
        await navigator.clipboard.writeText(url);
        if (this.$swal) {
          this.$swal({ icon: "success", title: "Link copied", text: url, timer: 1500, showConfirmButton: false });
        }
      } catch (e) {
        window.prompt("Copy this link:", url);
      }
    },

    // Some imported schools have lat/lng swapped (e.g. lat=-82.5, lng=27.9).
    normalizeSchoolCoords(school) {
      let rawLat = school?.lat;
      let rawLng = school?.lng;
      if (rawLat != null && typeof rawLat === "object") {
        rawLat = rawLat.latitude ?? rawLat._lat ?? rawLat._latitude;
        rawLng = rawLng?.longitude ?? rawLng?._long ?? rawLng?._longitude;
      }
      const lat = parseFloat(rawLat);
      const lng = parseFloat(rawLng);
      if (isNaN(lat) || isNaN(lng)) return { lat, lng };
      const latLooksValid = lat >= -90 && lat <= 90;
      const lngLooksValid = lng >= -180 && lng <= 180;
      const latLooksLikeLng = lat < -50 || lat > 50;
      const lngLooksLikeLat = lng > 0 && lng < 50;
      if (latLooksValid && lngLooksValid && latLooksLikeLng && lngLooksLikeLat) {
        return { lat: lng, lng: lat };
      }
      return { lat, lng };
    },

    _haversineMiles(lat1, lng1, lat2, lng2) {
      if ([lat1, lng1, lat2, lng2].some((v) => v == null || isNaN(v))) return NaN;
      const toRad = (d) => (d * Math.PI) / 180;
      const R = 3958.8; // miles
      const dLat = toRad(lat2 - lat1);
      const dLng = toRad(lng2 - lng1);
      const a =
        Math.sin(dLat / 2) ** 2 +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;
      return 2 * R * Math.asin(Math.sqrt(a));
    },

    _normalizeText(value) {
      return (value || "").toString().trim().toLowerCase();
    },

    escapeHtml(str) {
      return String(str ?? "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    },
    goToLink(link) { window.open(`https://${link}`, "_blank"); },
    scrollToSection(id) {
      const element = document.getElementById(id);
      if (element) {
        const headerOffset = 80;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition - headerOffset, behavior: "smooth" });
      }
    },
    handleHeaderClick() { this.convertLanguage(); },
    async convertLanguage() {
      const storedLanguage = localStorage.getItem("language");
      if (storedLanguage) this.language = storedLanguage;
      let lang = this.language;
      if (lang === "us") lang = "en";
      const converted = globalMixins.housing_assistance[lang];
      const pageHeader = globalMixins.pageHeader[lang];
      const pageFooter = globalMixins.pageFooter[lang];
      if (converted) {
        this.pageContent = { ...this.pageContent, ...converted };
        this.pageHeader = { ...this.pageHeader, ...pageHeader };
        this.pageFooter = { ...this.pageFooter, ...pageFooter };
      }
    },
  },
};
</script>


<style scoped>
html { scroll-behavior: smooth; }

.overlay-white {
  background-color: rgba(255, 255, 255, 0.95);
  padding: 50px;
  border-radius: 10px;
  color: black;
}

ul li { list-style: inside; font-size: 16px; }

/* ---------- Schools explorer layout ---------- */
.schools-explorer {
  display: flex;
  width: 100%;
  height: 800px;
  background: #fff;
  position: relative;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
}

/* ---------- Sidebar ---------- */
.explorer-sidebar {
  width: 400px;
  min-width: 400px;
  max-width: 400px;
  background: #fff;
  border-right: 1px solid #e5e7eb;
  display: flex;
  flex-direction: column;
  position: relative;
  transition: margin-left 0.25s ease;
  z-index: 5;
}
.explorer-sidebar.collapsed { margin-left: -400px; }

.sidebar-inner {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
}

.sidebar-toggle {
  position: absolute;
  top: 50%;
  right: -28px;
  transform: translateY(-50%);
  width: 28px;
  height: 56px;
  border: 1px solid #e5e7eb;
  border-left: none;
  background: #fff;
  border-radius: 0 8px 8px 0;
  box-shadow: 2px 0 6px rgba(0,0,0,0.08);
  cursor: pointer;
  color: #5f6368;
  z-index: 6;
}
.sidebar-toggle:hover { background: #f8f9fa; color: #1a73e8; }

/* Content */
.sidebar-content {
  flex: 1;
  overflow-y: auto;
  background: #fff;
}

/* Empty state (no school selected) */
.empty-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  padding: 32px 24px;
  text-align: center;
  color: #5f6368;
}
.empty-icon {
  font-size: 38px;
  color: #1a73e8;
  margin-bottom: 12px;
  opacity: 0.8;
}
.empty-title {
  font-size: 15px;
  font-weight: 600;
  color: #202124;
  margin-bottom: 6px;
}
.empty-sub {
  font-size: 13px;
  line-height: 1.5;
  max-width: 260px;
}

/* Details panel */
.details-panel { display: flex; flex-direction: column; }
.back-btn {
  display: inline-flex; align-items: center; gap: 6px;
  margin: 10px 14px; padding: 6px 10px;
  background: transparent; border: none;
  color: #1a73e8; font-size: 13px; cursor: pointer;
  border-radius: 4px;
}
.back-btn:hover { background: #f1f3f4; }

.details-header {
  padding: 18px 16px;
  color: #fff;
  background: #1a73e8;
}
.details-title { margin: 0; font-size: 20px; font-weight: 600; color: #fff; }

.details-actions {
  display: flex; gap: 8px;
  padding: 12px 14px;
  border-bottom: 1px solid #f1f3f4;
  flex-wrap: wrap;
}
.action-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 14px;
  background: #1a73e8; color: #fff;
  border: none; border-radius: 20px;
  font-size: 13px; cursor: pointer; text-decoration: none;
}
.action-btn:hover { background: #1765cc; color: #fff; }

.info-section { padding: 14px; border-bottom: 1px solid #f1f3f4; }
.section-heading {
  font-size: 13px; font-weight: 600; color: #202124;
  text-transform: uppercase; letter-spacing: 0.5px;
  margin: 0 0 10px;
}
.section-heading-row {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 10px;
}
.section-heading-row .section-heading { margin: 0; }
.radius-select { width: auto; font-size: 12px; }

.info-list { list-style: none; margin: 0; padding: 0; }
.info-list li {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 6px 0; font-size: 13px; color: #3c4043;
  list-style: none;
}
.info-list li i { color: #5f6368; margin-top: 3px; width: 16px; text-align: center; }
.info-list a { color: #1a73e8; text-decoration: none; }
.info-list a:hover { text-decoration: underline; }

/* Nearby categories */
.nearby-loading {
  display: flex; align-items: center; gap: 10px;
  padding: 16px; color: #5f6368; font-size: 13px;
}
.spinner {
  width: 18px; height: 18px;
  border: 2px solid #dadce0; border-top-color: #1a73e8;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}
.spinner-lg { width: 32px; height: 32px; border-width: 3px; }
@keyframes spin { to { transform: rotate(360deg); } }

.nearby-categories { display: flex; flex-direction: column; gap: 4px; }
.nearby-category { border-radius: 6px; overflow: hidden; }
.cat-header {
  display: flex; align-items: center; gap: 10px;
  width: 100%; padding: 8px 10px;
  background: #fff; border: 1px solid #f1f3f4;
  border-radius: 6px;
  cursor: pointer; text-align: left;
  font-size: 13px; color: #202124;
}
.cat-header:hover:not(:disabled) { background: #f8f9fa; }
.cat-header:disabled { opacity: 0.5; cursor: default; }
.cat-icon {
  display: inline-flex; align-items: center; justify-content: center;
  width: 26px; height: 26px; border-radius: 50%;
  color: #fff; font-size: 12px; flex-shrink: 0;
}
.cat-label { flex: 1; font-weight: 500; }
.cat-count {
  background: #f1f3f4; color: #5f6368;
  font-size: 11px; padding: 2px 8px; border-radius: 10px;
}
.cat-chevron { color: #5f6368; font-size: 11px; }

.cat-places { list-style: none; margin: 4px 0 8px; padding: 0; }
.cat-places li {
  padding: 10px 12px;
  background: #fafafa;
  border-radius: 4px;
  margin-bottom: 4px;
  cursor: pointer; transition: background 0.15s;
  list-style: none;
}
.cat-places li:hover { background: #eef3fb; }
.place-name { font-weight: 600; font-size: 13px; color: #202124; }
.place-meta {
  display: flex; gap: 12px; flex-wrap: wrap;
  margin-top: 4px;
  font-size: 12px; color: #5f6368;
}
.place-meta i { margin-right: 4px; }
.place-directions {
  display: inline-block; margin-top: 6px;
  font-size: 12px; color: #1a73e8; text-decoration: none;
}
.place-directions:hover { text-decoration: underline; }

/* ---------- Map panel ---------- */
.explorer-map-wrapper {
  flex: 1;
  position: relative;
  min-width: 0;
}
#googleMap {
  width: 100%;
  height: 100%;
  transition: none;
}

.map-toolbar {
  position: absolute;
  top: 14px; right: 60px;
  display: flex; flex-direction: column; gap: 6px;
  z-index: 4;
}
.tool-btn {
  width: 40px; height: 40px;
  border-radius: 6px;
  background: #fff;
  border: 1px solid rgba(0,0,0,0.1);
  box-shadow: 0 1px 4px rgba(0,0,0,0.18);
  color: #5f6368;
  cursor: pointer;
  font-size: 16px;
  transition: background 0.15s, color 0.15s;
}
.tool-btn:hover { background: #f8f9fa; color: #1a73e8; }
.tool-btn.active { background: #e8f0fe; color: #1a73e8; }

.measure-readout {
  position: absolute;
  top: 14px; left: 14px;
  background: #fff;
  padding: 8px 14px;
  border-radius: 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.18);
  font-size: 13px;
  z-index: 4;
  display: flex; align-items: center; gap: 8px;
}

.map-loading-overlay {
  position: absolute; inset: 0;
  background: rgba(255,255,255,0.7);
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  gap: 10px;
  color: #5f6368;
  font-size: 14px;
  z-index: 5;
}

.marker-label {
  text-shadow: -1px -1px 2px white, 1px -1px 2px white, -1px 1px 2px white,
    1px 1px 2px white;
}

/* ---------- Responsive ---------- */
@media (max-width: 900px) {
  .schools-explorer { flex-direction: column; height: auto; }
  .explorer-sidebar {
    width: 100%; min-width: 0; max-width: none;
    max-height: 50vh;
    border-right: none;
    border-bottom: 1px solid #e5e7eb;
  }
  .explorer-sidebar.collapsed { margin-left: 0; margin-top: -50vh; }
  .sidebar-toggle {
    top: auto; right: 14px; bottom: -28px;
    transform: none;
    width: 56px; height: 28px;
    border-radius: 0 0 8px 8px;
    border: 1px solid #e5e7eb;
    border-top: none;
  }
  .explorer-map-wrapper { height: 600px; }
  .map-toolbar { right: 14px; top: 14px; }
}
</style>

<!--
  Marker DOM nodes are appended by Google Maps outside this component's
  scoped CSS boundary, so their styles MUST live in a non-scoped block.
-->
<style>
.place-marker .place-pin {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.3);
  border: 2px solid #fff;
  cursor: pointer;
  transition: transform 0.15s ease;
}
.place-marker .place-pin.hover { transform: scale(1.25); }

/* Mimic the classic google.maps.Marker DROP animation */
.selected-school-drop {
  transform-origin: 50% 100%;
  animation: selected-school-drop 0.45s cubic-bezier(0.34, 1.2, 0.64, 1) 1;
}
@keyframes selected-school-drop {
  0% { transform: translateY(-220px); opacity: 0; }
  60% { transform: translateY(0); opacity: 1; }
  75% { transform: translateY(-12px); }
  100% { transform: translateY(0); }
}
</style>
